import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from './hooks';
import { getSettings } from './store/WebSettingsSlice';
import useWindowMessages from './hooks/useWindowMessages';
import useCheckSettings from './hooks/useCheckSetting';
import AnimatedRoutes from './AnimatedRoutes';


import TheHeader from './components/TheHeader';
import TheFooter from './components/TheFooter';
import MessageModal from './components/MessageModal';
import LoaderSpinner from './components/LoaderSpinner';

import './App.scss';

function App() {

  const { loading } = useAppSelector(state => state.webSettings);
  const dispatch = useAppDispatch();

  useWindowMessages();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useCheckSettings();

  return (
    <main id="app" className="h-screen">
      <MessageModal />
      <TheHeader />
      { loading === 'succeeded' ?
        <AnimatedRoutes /> :
        <LoaderSpinner />
      }
      <TheFooter />
    </main>
  );
}

export default App;
